import { render, staticRenderFns } from "./OnboardingOptions.vue?vue&type=template&id=b5ef042c&scoped=true&"
import script from "./OnboardingOptions.vue?vue&type=script&lang=js&"
export * from "./OnboardingOptions.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingOptions.vue?vue&type=style&index=0&id=b5ef042c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ef042c",
  null
  
)

export default component.exports